import { render, staticRenderFns } from "./CheckBoxList.vue?vue&type=template&id=0edfc53a&scoped=true"
import script from "./CheckBoxList.vue?vue&type=script&lang=ts"
export * from "./CheckBoxList.vue?vue&type=script&lang=ts"
import style0 from "./CheckBoxList.vue?vue&type=style&index=0&id=0edfc53a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edfc53a",
  null
  
)

export default component.exports